// extracted by mini-css-extract-plugin
module.exports = {"news":"news_news__dX6py","loading":"news_loading__8efcS","compactnews":"news_compactnews__jaMq8","empty":"news_empty__wZCdA","fade":"news_fade__JwEMu"};